import { Image } from '$partials/media';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */
/**
 * @type {import('$types/components/partials/modules.d.ts').Offices}
 */
const Offices = ({
    items,
}) => {

    // render
    return (
        <div className='flex flex-wrap'>
            {items.map((item, idx) => {
                if (!item) { return null; }
                const { title, image, body } = item;
                const totalOffices = items.filter(office => !office.item)?.length;
                const isLastThree = idx >= totalOffices - 3;
                return(
                    <div
                        className={`bg-white ${totalOffices === 2 || totalOffices % 2 === 0 ? 'md-col-6' : totalOffices === 3 || isLastThree ? 'md-col-4 border-left border-right' : 'md-col-6'} col-12 border-grey border-bottom border-top${idx % 2 === 0 ? ' border-right' : ' border-left'}`}
                        key={`office-${idx}`}>
                        <div className='pl5 pt5 pr5 pb6 sm-pr0 sm-pb8 md-pl6 md-pt6'>
                            <div className='flex flex-col sm-flex-row md-flex-col'>
                                <div className={`col-12 sm-pr7 sm-col-6 ${totalOffices === 3 || isLastThree ? 'md-pr6 md-col-12' : 'md-pr6 md-col-8'}`}>
                                    <Image {...image} />
                                </div>
                                <div className='flex flex-col'>
                                    <h3 className='type-style-3 mt5 sm-mt0 md-mt6'>{title}</h3>
                                    <div
                                        className='rich-text contact-details type-style-6 link-reset mt5'
                                        dangerouslySetInnerHTML={{__html: body}} />
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Offices;
